/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

const APP_DOMAIN = 'power_partner_data' as string
export const snake = window?.[APP_DOMAIN]?.env?.SNAKE || 'my_app'
export const appName = window?.[APP_DOMAIN]?.env?.APP_NAME || 'My App'
export const kebab = window?.[APP_DOMAIN]?.env?.KEBAB || 'my-app'
export const app1Selector = window?.[APP_DOMAIN]?.env?.APP1_SELECTOR || 'my_app'
export const app2Selector =
    window?.[APP_DOMAIN]?.env?.APP2_SELECTOR || 'my_app_metabox'
export const apiUrl = window?.wpApiSettings?.root || '/wp-json'
export const ajaxUrl =
    window?.[APP_DOMAIN]?.env?.ajaxUrl || '/wp-admin/admin-ajax.php'
export const siteUrl = window?.[APP_DOMAIN]?.env?.siteUrl || '/'
export const currentUserId = Number(window?.[APP_DOMAIN]?.env?.userId ?? 0)
export const currentUserEmail: string = window?.[APP_DOMAIN]?.env?.userEmail || ''
export const postId = window?.[APP_DOMAIN]?.env?.postId || '0'
export const permalink = window?.[APP_DOMAIN]?.env?.permalink || '/'
export const apiTimeout = '300000'
export const is_kiwissec = window?.[APP_DOMAIN]?.env?.is_kiwissec || false

export const myAccountUrl = window?.[APP_DOMAIN]?.env?.myAccountUrl || '/my-account'

// cloud site API：一律打本站 PHP proxy（由 PHP 加上雲端認證後轉送），
// 瀏覽器不持有任何雲端憑證；<path> 與雲端 power-partner-server 的路徑完全相同。
// 去掉 root 結尾的 /，避免 useDownloadDetail 的原生 fetch 組出 //power-partner（axios 會自行處理，fetch 不會）
export const cloudProxyUrl = `${apiUrl.replace(/\/+$/, '')}/power-partner/cloud`

// 舊版把經銷商帳密以可逆密文存在 localStorage 的 key，現在只用於開機時清除殘留
export const LOCALSTORAGE_ACCOUNT_KEY = 'power-partner-account'

export const nonce = window?.[APP_DOMAIN]?.env?.nonce || ''
export const allowed_template_options = (window?.[APP_DOMAIN]?.env
    ?.allowed_template_options || []) as {
    [key: string]: string
}

export const partner_id: string = window?.[APP_DOMAIN]?.env?.partner_id || ''
export const disable_site_after_n_days: number =
    window?.[APP_DOMAIN]?.env?.disable_site_after_n_days ?? 7

// 是否允許在「所有站台」列表顯示「刪除網站」按鈕（UI 層防呆，非伺服器端權限）
export const allow_delete_site: boolean =
	window?.[APP_DOMAIN]?.env?.allow_delete_site ?? false

export const POWERCLOUD_API = window?.[APP_DOMAIN]?.env?.POWERCLOUD_API || ''
export const powercloud_api_key: string =
    window?.[APP_DOMAIN]?.env?.powercloud_api_key || ''